module.exports = __webpack_public_path__ + "static/media/SharedKitchen.8c4203e1.png";